export const ARTICLE_TITLE_DEFAULT_VALUE = '<h1><br></h1>';

/** ReactQuill config for article title blocks */
export const ARTICLE_TITLE_MODULES = {
    toolbar: [
        [{ header: [1, 2] }],
        ['bold', 'italic', 'underline'],
        [{ align: '' }, { align: 'center' }, { align: 'justify' }, { align: 'right' }],
    ],
};

export const ARTICLE_TITLE_FORMATS = ['header', 'bold', 'italic', 'underline', 'align'];

/** ReactQuill config for article text blocks */
export const ARTICLE_TEXT_MODULES = {
    toolbar: [
        [{ header: [1, 2, false] }],
        ['bold', 'italic', 'underline'],
        [{ align: '' }, { align: 'center' }, { align: 'justify' }, { align: 'right' }],
        [{ list: 'ordered' }, { list: 'bullet' }],
        ['link'],
        ['clean'],
    ],
};

export const ARTICLE_TEXT_FORMATS = ['header', 'bold', 'italic', 'underline', 'align', 'list', 'bullet', 'link'];
